import { useBreakpointValue } from '@chakra-ui/react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useIsNewUser } from '#modules/user/features/onboarding/hooks/useIsNewUser';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/'
)({
  component: SettingsIndex,
  ssr: false,
});

/**
 * The section list itself is the layout's left pane, so this route only decides what a wide
 * screen shows next to it: there is no "settings overview" page, so it opens the first section.
 *
 * `replace` keeps the redirect out of the history — otherwise Back from Profile would land here
 * and be bounced forward again, trapping the user inside settings. The search is carried over
 * because `?newUser=true` (set by the sign-up guard) is what triggers the onboarding popup.
 */
function SettingsIndex() {
  const navigate = useNavigate();
  const isWide = useBreakpointValue({ base: false, lg: true }, { ssr: false });
  const isNewUser = useIsNewUser();

  useEffect(() => {
    // Новичка пропускаем к форме на любой ширине: приветственный попап живёт внутри неё, а на
    // телефоне этот список — тупик. Прод до выкатки нового teamplay-user приводит сюда каждого,
    // кто зарегистрировался через провайдера, так что без этой ветки телефон остаётся без
    // онбординга ровно до момента выкатки бэкенда.
    if (!isWide && !isNewUser) {
      return;
    }

    void navigate({
      to: '/{-$locale}/dashboard/settings/profile',
      search: (prev) => prev,
      replace: true,
    });
  }, [isWide, isNewUser, navigate]);

  return null;
}
